var Size = /** @class */ (function () {
    function Size(wth, ht) {
        this.width = wth;
        this.height = ht;
    }
    return Size;
}());
export default Size;
